import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'website-link-third-party-glyph-icon'

export function WebsiteLinkSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M11.71 18.502a1.789 1.789 0 0 1 .36-2.503c.79-.592 1.91-.43 2.502.36a5.36 5.36 0 0 0 8.085.58l4.267-4.27a5.368 5.368 0 0 0-.066-7.52c-2.067-2.07-5.411-2.1-7.497-.084L16.902 7.51c-.7.696-1.83.693-2.527-.007a1.79 1.79 0 0 1 .008-2.53L16.86 2.51a8.93 8.93 0 0 1 12.526.109c3.446 3.45 3.495 9.026.087 12.557l-4.289 4.292a8.931 8.931 0 0 1-13.474-.966Zm8.58-5.004a1.79 1.79 0 0 1-.36 2.503c-.79.592-1.91.43-2.502-.36a5.36 5.36 0 0 0-8.085-.58l-4.267 4.27a5.368 5.368 0 0 0 .066 7.52c2.068 2.07 5.411 2.1 7.493.088l2.444-2.446a1.786 1.786 0 0 1 2.528 0 1.79 1.79 0 0 1 0 2.529L15.14 29.49a8.93 8.93 0 0 1-12.526-.109c-3.446-3.45-3.495-9.026-.087-12.557l4.289-4.292a8.932 8.932 0 0 1 13.474.966Z" />
    </symbol>
  )
}

const WebsiteLinkStandaloneContent = standalone(WebsiteLinkSymbol, ID)

export const WebsiteLink = styled(function WebsiteLinkStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-website-link">
      <WebsiteLinkStandaloneContent />
    </Icon>
  )
})``

export const WebsiteLinkLightweight = styled(function WebsiteLinkComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-website-link">
      {lightweight(ID)}
    </Icon>
  )
})``
